module.exports = __webpack_public_path__ + "static/media/20171211-_DSC1863_Small.5bec9505.jpg";